import React from 'react';
import './TermsModal.css';

export const PrivacyPolicy = () => {
    return (
        <div className="terms-page-container" style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto', color: 'white', fontFamily: 'Inter, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontSize: '32px', margin: 0 }}>Privacy Policy</h1>
                <a href="/" style={{ color: '#a855f7', textDecoration: 'none', fontWeight: 'bold' }}>← Back to Home</a>
            </div>
            
            <div style={{ background: 'rgba(30, 30, 50, 0.5)', padding: '30px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)', lineHeight: '1.6' }}>
                <h3 style={{ marginTop: 0, color: '#d8b4fe' }}>1. Data Collection</h3>
                <p>
                    We collect the data you explicitly provide to us to generate your personalized brain profile. This includes:
                </p>
                <ul style={{ paddingLeft: '20px', opacity: 0.9 }}>
                    <li>Handwriting images (processed temporarily for structural analysis).</li>
                    <li>Quiz responses and behavioral selections.</li>
                    <li>Basic account information provided during sign-up (e.g., email address, name).</li>
                </ul>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>2. How We Use Your Data</h3>
                <p>
                    Your data is used solely to:
                </p>
                <ul style={{ paddingLeft: '20px', opacity: 0.9 }}>
                    <li>Generate your unique character cards and compatibility insights.</li>
                    <li>Provide personalized AI coaching suggestions (if enabled).</li>
                    <li>Maintain and secure your account.</li>
                </ul>
                <p>
                    <strong>Privacy First:</strong> When analyzing handwriting, we look at patterns (slants, loops, pressure) and not the actual words. Your uploaded images are processed securely and deleted instantly from our AI processing nodes after the analysis is complete.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>3. Data Sharing</h3>
                <p>
                    <strong>We do not sell your personal data to third parties.</strong> We only share minimal necessary data with trusted service providers (such as OpenAI for generating insights) strictly for the purpose of operating our service. These providers do not use your data to train their models.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>4. Your Rights</h3>
                <p>
                    You have full control over your data. You may request to view, export, or permanently delete your account and associated data at any time by accessing your account settings or contacting support.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>5. Security</h3>
                <p>
                    We implement industry-standard security measures to protect your information. However, no method of transmission over the internet is 100% secure.
                </p>
                
                <p style={{ marginTop: '40px', opacity: 0.5, fontSize: '12px' }}>
                    Last Updated: May 2026
                </p>
            </div>
        </div>
    );
};
